import React from 'react'
import Check from "../../../../assets/images/success.gif"

const ConnectedExchange = () => {
    return (
        <div>
            <div className="onboardingContentBox">
                <h2 className="title">
                    <span>Exchange account connected!</span>
                </h2>
                <p className="desc">
                    Please hold 
                </p>
                <img className='sucessGif' src={Check} alt="Check Loader" />
            </div>
        </div>
    )
}

export default ConnectedExchange